import React from 'react';
import { __, Message } from 'first-intl';

export type NotAvailablePageProps = { error?: Message };

export const NotAvailablePage: React.FC<NotAvailablePageProps> = ({ error }) => (
    <div className="container-fluid">
        <h1>{__('page.NotAvailable.title')}</h1>
        {error && __(error)}
    </div>
);
